var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FFCF01"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8792 15.4489C22.4259 14.5475 23.3984 14 24.447 14C25.4957 14 26.4682 14.5475 27.0149 15.4489L35.493 29.6027C36.0261 30.5258 36.0292 31.6624 35.5014 32.5885C34.9735 33.5145 33.9939 34.091 32.917 34.1027L15.966 34.1027C14.9002 34.091 13.9205 33.5145 13.3927 32.5885C12.8648 31.6624 12.868 30.5258 13.4092 29.5889L21.8792 15.4489Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.447 25.1027V21.1027C23.447 20.5505 23.8947 20.1027 24.447 20.1027C24.9993 20.1027 25.447 20.5505 25.447 21.1027V25.1027C25.447 25.655 24.9993 26.1027 24.447 26.1027C23.8947 26.1027 23.447 25.655 23.447 25.1027ZM25.1541 27.3956C25.5447 27.7862 25.5447 28.4193 25.1541 28.8099C24.7636 29.2004 24.1304 29.2004 23.7399 28.8099C23.3494 28.4193 23.3494 27.7862 23.7399 27.3956C24.1304 27.0051 24.7636 27.0051 25.1541 27.3956Z",
    fill: "#FFCF01"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.d6ab1649a89cc156bed4db17e4098566.svg";
export { ForwardRef as ReactComponent };